import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-view-claim-ledger',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './view-ledger.component.html',
  styleUrl: './view-ledger.component.css'
})
export class ViewLedgerComponent {

}
